import React from 'react'
import Select from 'react-select'

export default function WidgetBranchMultiSelector({ onChange, Branches, value }) {
    const handleMultiSelect = (options) => {
        if (options.length) {
            if (options[0].value === '*') {
                onChange([...Branches])
            }
            else {
                onChange(options)
            }
        }
        else {
            onChange([])
        }
    }

    const customStyles = {
        container: (provided) => ({
            ...provided,
            width: "100%",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    };

    return (
        <Select
            isMulti
            options={[{ value: '*', label: 'Select All' }, ...Branches]}
            onChange={handleMultiSelect}
            value={value}
            styles={customStyles}
        />
    )
}
